// A full document navigation applies the early counter opt-out before GTM runs.
export default defineNuxtPlugin(nuxt => {
  const isAdmin = (path: string) => /^\/admin(?:\/|$)/.test(path);
  nuxt.$router.beforeEach((to, from) => {
    if (isAdmin(to.path) !== isAdmin(from.path)) {
      window.location.assign(to.fullPath);
      return false;
    }
  });
});
